var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAceleresLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 130,
    viewBox: "0 0 436 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.2 125C143.8 125 147.3 121.4 147.3 116.3C147.3 111.2 143.8 107.7 139.2 107.7C136.2 107.7 133.7 109.1 132.5 111.6V101.9H130.2V124.6H132.5V121.1C133.7 123.5 136.3 125 139.2 125ZM138.9 122.9C135.2 122.9 132.5 120.3 132.5 116.4C132.5 112.5 135.1 109.9 138.9 109.9C142.5 109.9 145.1 112.6 145.1 116.4C145 120.2 142.5 122.9 138.9 122.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.7 122.2L150.6 108H148.2L155.5 124.6L153.1 130H155.5L157.8 124.7L165.2 108H162.8L156.7 122.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.6 125C189.2 125 193.3 123.1 193.3 119C193.3 115.1 190.3 113.6 185.1 112.6C181.1 111.7 179.2 111 179.2 108.7C179.2 105.9 181.8 105 184.9 105C187.1 105 189.3 105.5 191.6 106.7L192 104.5C189.7 103.4 187.3 102.9 184.8 102.9C180.4 102.9 176.6 104.8 176.6 108.9C176.6 112.3 179.3 113.8 184.4 114.8C188.3 115.7 190.7 116.4 190.7 119.2C190.7 122.1 187.8 123 184.5 123C181.9 123 178.6 122.4 176.2 121.1L175.9 123.3C178.2 124.4 181.4 125 184.6 125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.2 113.7C213.6 113 215 111.1 215 108.6C215 105.2 212.3 103.2 208 103.2H197.9V124.8H208.4C213.1 124.8 216 122.6 216 119.1C216 116.3 214.2 114.2 211.2 113.7ZM207.4 105.3C210.8 105.3 212.6 106.6 212.6 109C212.6 111.3 210.9 112.7 207.6 112.7H200.1V105.3H207.4ZM200.2 122.6V114.9H208C211.6 114.9 213.6 116.2 213.6 118.8C213.6 121.2 211.7 122.6 207.9 122.6H200.2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.7 121.9H219.7V124.7H222.7V121.9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.5 124.7V122.6H238.8V103.1H236.4V124.7H251.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.7 107.8C258.7 107.8 256.6 108.2 254.8 108.9L255.1 111C256.7 110.3 258.6 109.9 260.5 109.9C263.8 109.9 265.5 111.3 265.5 114.3V115.1C263.8 114.9 261.8 114.8 259.7 114.8C255.3 114.8 253.3 117 253.3 120C253.3 123 255.5 125.1 259.1 125.1C262.4 125.1 264.6 123.2 265.5 121.5V124.8H267.8V114.4C267.8 110.2 265.4 107.8 260.7 107.8ZM259.8 122.9C257.1 122.9 255.6 121.8 255.6 119.8C255.6 117.8 257 116.6 260.4 116.6C262.4 116.6 263.9 116.7 265.5 117V117.5C265.5 120.1 263.5 122.9 259.8 122.9Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.7 125C286.3 125 289.8 121.4 289.8 116.3C289.8 111.2 286.3 107.7 281.7 107.7C278.7 107.7 276.2 109.1 275 111.6V101.9H272.7V124.6H275V121.1C276.2 123.5 278.8 125 281.7 125ZM281.4 122.9C277.7 122.9 275 120.3 275 116.4C275 112.5 277.6 109.9 281.4 109.9C285 109.9 287.6 112.6 287.6 116.4C287.5 120.2 285 122.9 281.4 122.9Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.4 125C303.1 125 306.2 123.4 306.2 120.1C306.2 117.5 304.7 116.1 299.8 115.1C296.3 114.4 295.3 113.7 295.3 112.3C295.3 110.7 296.8 109.9 299.2 109.9C301.3 109.9 303.2 110.3 304.8 111.2L305.2 109C303.4 108.3 301.5 107.8 299.4 107.8C295.8 107.8 293 109.4 292.9 112.5C292.9 115 294.3 116.4 299.1 117.3C302.6 117.9 303.8 118.6 303.8 120.2C303.8 122.1 301.8 122.9 299.4 122.9C297.1 122.9 294.8 122.3 292.8 121.3L292.3 123.5C294.4 124.4 296.7 125 299.4 125Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.4 35.3001L96.3 33.1002C94.5 36.4002 92.4 38.8002 89 40.6002C77.6 46.6002 63.7 38.5 63.7 25.4C63.7 8.49999 85.2 1.70004 94.9 15.2C95.5 16 95.8 16.8001 96.3 17.5001L100.4 15.4C99.8 13.6 97.6 11 96.5 9.89999C83.2 -3.80001 59.1001 5.10018 58.8001 25.1002C58.5001 44.4002 82.3 54.9001 96.4 40.8001C97.6 39.7001 99.8 37.1001 100.4 35.3001Z",
    fill: "#818080"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307 8.19988C312.7 8.19988 316.4 16.5998 311.2 20.8998C308.3 23.2998 306.4 22.8 302 22.8C298.4 22.8 294.7 22.8 291.1 22.8C291.4 23.6 296 27.9 296.9 28.8L311.6 43.6C312.5 44.5 313.5 45.7999 314.5 46.4999C315.2 46.0999 317.2 43.8999 317.9 43.1999C317 41.9999 311.7 36.7998 310.2 35.3998L302.6 27.6999C304.5 27.3999 306.6 27.7998 308.7 27.3998C313.3 26.4998 317.3 22.9 318.3 17.8C319.9 9.49998 312.4 2.99993 307.4 3.49993C305.3 3.69993 302.2 3.49993 299.9 3.49993H277.3V8.10003C282.3 8.10003 287.3 8.10003 292.3 8.10003C294.5 8.10003 304.3 8.00003 306.4 8.10003L307 8.19988Z",
    fill: "#C2C1C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800049 43.2C1.10005 43.9 3.60005 46.3001 4.10005 46.6001C4.90005 46.3001 7.70005 43.1999 8.50005 42.3999L30.1001 20.5C31.2001 19.3 38.2 12.1 38.9 11.7V45H43.7V0.199951C43.2 0.299951 43.3 0.299951 43 0.699951C42.7 0.999951 42.6 1.0999 42.3 1.3999C39.8 4.0999 35.6 8.20005 33 10.8L22.3 21.6001C20.5 23.4001 18.7 25.1 16.9 27C15.1 28.8 13.4001 30.5999 11.6001 32.3999L0.800049 43.2Z",
    fill: "#4D4B4D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.2 47.3999L207.8 47.3V42.7H180.9V3.3999H176.1L176.2 47.3999Z",
    fill: "#A2A2A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.1 47.3999H257.3V42.6001H218.1V47.3999Z",
    fill: "#A2A2A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.1 8.1001H257.2L257.3 3.3999H218.2L218.1 8.1001Z",
    fill: "#A2A2A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 8.1001H159.1V3.3999H120V8.1001Z",
    fill: "#818080"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 47.3999H159.1V42.6001L120 42.7V47.3999Z",
    fill: "#818080"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.1 47.3999L375.2 47.3V42.7H336.1V47.3999Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.2 8H375V7.3999V3.5H336.2V8Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.1 27.6998H248.2V22.9999C247.4 22.7999 219.4 22.6999 218.1 22.9999V27.6998Z",
    fill: "#A2A2A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 27.7L150.1 27.8L150.2 23.1001L120 23V27.7Z",
    fill: "#818080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.1 27.7L366.2 27.8V23.1001L336.1 23V27.7Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.3 47.3999H281.7V35.2H277.4H277.2L277.3 47.3999Z",
    fill: "#C2C1C2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20011 4.99991C3.20011 5.89991 4.80011 12.6999 9.30011 11.9999C11.0001 11.6999 12.5001 9.99981 12.2001 7.89981C11.8001 6.19981 10.1001 4.69991 8.20011 4.99991Z",
    fill: "#C8312C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.2 3.5H375V7.3999V8H336.1V3.5H336.2ZM336 8.1001H375.2L375.3 3.30005H336.1L336 8.1001Z",
    fill: "#A2A2A2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307 8.19994L306.3 7.99999C304.3 7.89999 294.4 7.99999 292.2 7.99999C287.2 7.99999 282.2 7.99999 277.2 7.99999V3.39989H299.8C302.1 3.39989 305.2 3.59989 307.3 3.39989C307 3.29989 307.6 3.40004 307 3.30004C305.9 3.10004 277.8 3.20004 277.1 3.30004V8.10009L307 8.19994Z",
    fill: "#818080"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.3 47.4L277.2 35.2H277.4H281.8L281.7 47.4C281.9 47.2 281.9 47.6 282 46.7V35.1002C281.1 34.9002 278.1 34.9002 277.2 35.1002V46.9C277.1 47.5 276.9 47.2 277.3 47.4Z",
    fill: "#818080"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.9 8H423.8V3.3999H407.9C406.2 3.3999 404.5 3.4 402.8 3.5C399.9 3.2 395.9 6.4001 394.9 7.6001C388.2 16.5001 393.9 27.8 405 27.8C406.8 27.8 408.5 27.8 410.3 27.8H419.1C422 27.7 425.2 27.6999 427.2 28.8999C433.7 32.6999 430.7 42.4 424.3 42.7C424.1 42.9 421.4 43 418 43H394.4V47.6001H418C420.3 47.6001 422.6 47.6 424.8 47.5C427.7 47.8 431.7 44.5999 432.7 43.3999C439.4 34.4999 433.7 23.2 422.6 23.2C420.8 23.2 419.1 23.2 417.3 23.2H410.2H410.1H406.9V23.3C404.4 23.3 402 23.2 400.3 22.2C393.8 18.4 396.8 8.6999 403.2 8.3999C403.5 8.0999 405.4 8 407.9 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceleresLogo);
export default __webpack_public_path__ + "static/media/aceleres_logo.87213c9cf9d7cfd7a8a1a5c67a532cba.svg";
export { ForwardRef as ReactComponent };